import React from 'react'
import Header from '../../Global/Header'
import Breadcrumb from '../../Global/Breadcrumb'
import LookInside from '../../Menhomeone/LookInside'
import LessonFlow from '../../Menhomeone/LessonFlow'
import Footer from '../../Global/Footer'
import Gototop from '../../Global/Gototop'
import { siteCopy } from '../../../content/siteCopy'

const Main = () => (
  <>
    <Header />
    <Breadcrumb Title={siteCopy.features.breadcrumbTitle} Subtitle="Features" />
    <div className="page_wrapper page_wrapper--features">
      <LookInside />
      <LessonFlow />
      <Footer />
      <Gototop />
    </div>
  </>
)

export default Main
